import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlined';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutlined';
import { Link } from 'react-router-dom';

const useStyles = makeStyles()({
  Root: {
    display: 'flex',

    '& .success': {
      color: '#4abc4e',

      '& svg': {
        position: 'relative',
        top: 7,
      },
    },
    '& .error': {
      color: 'red',

      '& svg': {
        position: 'relative',
        top: 7,
      },
    },
  },

  Link: {
    display: 'inline-block',
    position: 'relative',
    top: 8,
    color: '#4a9eff',
  },
});

function GeocodeResult(props) {
  const { data, status } = props;
  const { classes } = useStyles();

  let statusText;

  if (status) {
    statusText = (
      <Box component="div" class="success" sx={{ display: 'inline-block' }}>
        <CheckCircleOutlineIcon display="inline-block" />
        Successfully Geocoded:
      </Box>
    );
  } else {
    statusText = (
      <Box component="div" class="error" sx={{ display: 'inline-block' }}>
        <ErrorOutlineIcon display="inline-block" />
        Geocoded Failed (please mannually input Latitude and Longitude)
      </Box>
    );
  }
  function handleClick(e) {
    e.preventDefault();
    if (status) {
      window.open(`https://www.google.com/maps/search/?api=1&query=${data.address.lat},${data.address.lng}`);
    } else {
      window.open(
        `https://www.google.com/maps/search/${data.address.street}, ${data.address.city}, ${data.address.state}`,
      );
    }
  }
  return (
    <div className={classes.Root}>
      {statusText}
      {status && (
        <Link target="_blank" href="#" color="inherit" className={classes.Link} onClick={handleClick}>
          {data.address.street + ', ' + data.address.city + ', ' + data.address.state}
        </Link>
      )}
    </div>
  );
}

export default GeocodeResult;
